import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


export const PermissionsTabSkeleton = () => (
    <Item className="pd-l">
        <Group alignItems="stretch" gap="xxl">
            <div style={{width: 840}}>
                <FormSection headline="Role Permissions" info={() => <SkeletonItem width={170} height={28}/>}>
                    <Table>
                        <Head>
                            <Cell width={400}><SkeletonItem width={150} height={18}/></Cell>
                            <Cell width={100} className="text-align_center">
                                <Item grow={1}>
                                    <SkeletonItem width={70} height={18}/>
                                </Item>
                            </Cell>
                        </Head>
                        <Body>
                            {Array.from({length: 30}, (permission, i) => (
                                <Row key={i}>
                                    <Cell width={400}><SkeletonItem width={150} height={18}/></Cell>
                                    <Cell width={100}>
                                        <Item grow={1} className="pdy-xs">
                                            <SkeletonItem width={18} height={18}/>
                                        </Item>
                                    </Cell>
                                </Row>
                            ))}
                        </Body>
                    </Table>
                </FormSection>
            </div>
            <Item grow={1}>
                <FormSection
                    headline="Activity Log"
                    info={() => (
                        <Item grow={1}>
                            <Group justify="space-between">
                                <SkeletonItem width={170} height={28}/>
                                <Group>
                                    <SkeletonItem width={60} height={18}/>
                                    <SkeletonItem width={90} height={18}/>
                                </Group>
                            </Group>
                        </Item>
                    )}>
                    <div/>
                </FormSection>
            </Item>
        </Group>
    </Item>
);
